import { dollarsToCents } from "./review-domain.ts";
import type { ProjectFinding } from "./project-workflow.ts";

type Quotation = { supplierId: string; manufacturer: string; quoteNumber: string; freight: string };
export function selectedSupplierFreight(findings: ProjectFinding[], selected: Record<string, string>, quotations: Record<string, Quotation>) {
  const keys = new Set<string>();
  for (const finding of findings) {
    if (finding.decision !== "estimate" || !finding.evidenceReviewed) continue;
    for (const part of finding.parts) {
      const key = selected[part.id]; const quote = key ? quotations[key] : undefined;
      if (!key || !quote || part.sourceType !== "supplier" || !part.sourceConfirmed || !part.supplierId) continue;
      const expected = `${encodeURIComponent(finding.manufacturer.trim())}::${part.supplierId.trim()}::quote::${quote.supplierId}`;
      if (key === expected && quote.supplierId === part.supplierId && quote.manufacturer === finding.manufacturer) keys.add(key);
    }
  }
  const groups = new Map<string, { keys: string[]; supplierId: string; quoteNumber: string; values: Array<number | null> }>();
  for (const key of keys) {
    const quote = quotations[key]!;
    // One supplier quote can cover several manufacturer/component RFQ packages.
    const groupKey = quote.quoteNumber.trim() ? JSON.stringify([quote.supplierId, quote.quoteNumber.trim().toLowerCase()]) : key;
    const group = groups.get(groupKey) ?? { keys: [], supplierId: quote.supplierId, quoteNumber: quote.quoteNumber.trim(), values: [] };
    group.keys.push(key); group.values.push(dollarsToCents(quote.freight)); groups.set(groupKey, group);
  }
  const lines = [...groups.values()].map((group) => {
    const values = new Set(group.values);
    const amountCents = values.size === 1 && !values.has(null) ? group.values[0]! : null;
    return { keys: group.keys, supplierId: group.supplierId, quoteNumber: group.quoteNumber, amountCents, issue: amountCents !== null ? "" : values.size > 1 ? "Conflicting freight for the same supplier quote; reconcile it or use a manual total." : "Enter freight or 0.00 on the selected supplier quote." };
  });
  const total = lines.reduce((sum, line) => sum + (line.amountCents ?? 0), 0);
  const ready = lines.every((line) => line.amountCents !== null) && Number.isSafeInteger(total);
  return { lines, ready, amount: ready ? (total / 100).toFixed(2) : "" };
}
